import { GRAY_2, GRAY_LIGHT, TRIMBLE_GRAY } from './mc-tokens';

export const MODUS_MENU_STYLESHEET = `
  modus-wc-menu-item.tc-modus-menu-item--hidden,
  li.tc-modus-menu-skeleton.tc-modus-menu-item--hidden {
    display: none;
  }
    
  modus-wc-menu {
    hr {
      margin: 1rem 0;
      border: none;
      border-top: solid 0.0625rem ${GRAY_2};
    }
    & .modus-wc-menu-item-labels {
      padding-inline-start: var(--modus-wc-spacing-xs) !important;
    }

    & .dropdown-list {
      & li {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        font-size: 0.875rem;
        padding: 0.5rem 0rem;
        text-align: left;
        height: 2.5rem;
        color: ${TRIMBLE_GRAY};

        &:hover {
          background-color: ${GRAY_LIGHT};
          cursor: pointer;
        }
      }
    }

    & modus-wc-menu-item li button:active, button:focus {
      background-color: transparent !important;
    }

    & li.tc-modus-menu-skeleton {
      pointer-events: none;

      &:hover {
        background-color: transparent;
        cursor: default;
      }

      & .tc-modus-menu-skeleton-bar {
        display: block;
        height: 1rem;
        width: 13rem;
        background-color: #EAEAEF;
        border-radius: 0.125rem;
      }
    }
  }
    
}
`;
